module.exports = __webpack_public_path__ + "static/media/998205.f016aa26.png";